(function () {
	String.prototype.format = String.prototype.format || function () {
		var str = this.toString();
		if (arguments.length) {
			var t = typeof arguments[0],
				key,
				args = ("string" === t || "number" === t) ? Array.prototype.slice.call(arguments) : arguments[0];

			str = str.replace(/{(\d+)}/gi, function (match, offset) {
				return typeof args[offset] != 'undefined' ? args[offset] : match;
			});
		}

		return str;
	};

	String.format = String.format || function (format) {
		var args = Array.prototype.slice.call(arguments, 1);
		return format.replace(/{(\d+)}/gi, function (match, offset) {
			return typeof args[offset] != 'undefined' ? args[offset] : match;
		});
	};
})();